export const AITrafficFutureConfig = {
    "aitraffic.**": {
        url: "/digitalsuite/ai-traffic",
        lazyLoad: () => import("./AITrafficConfig"),
    },
};
